import { useLayoutEffect, useRef, useState } from 'preact/hooks';
import { Segmented } from './Segmented';

/**
 * The Show only · Hide switch (Filters panel, Reference's subgenre chips): the one view switch,
 * Segmented (R3 P3), with its own words. "Show only" wherever it fits on one line; "Show" only
 * where the extra word would make the label wrap (Kristi, Oct 30: changing it to "Show"
 * everywhere on Oct 29 was for the phone). Checked on every resize.
 */
export function ShowHide({ mode, onPick, label }: { mode: 'show' | 'hide'; onPick: (m: 'show' | 'hide') => void; label: string }) {
  const host = useRef<HTMLSpanElement>(null);
  const [short, setShort] = useState(false);
  useLayoutEffect(() => {
    const wrap = host.current;
    const el = wrap?.querySelector<HTMLElement>('.seg');
    if (!wrap || !el) return;
    let width = -1;
    const check = () => {
      const w = wrap.parentElement?.clientWidth ?? 0;
      if (w === width) return;
      width = w;
      // Try the long label; keep it only if both buttons stay on one line, side by side.
      wrap.dataset.short = 'false';
      const [show, hide] = Array.from(el.querySelectorAll('button'));
      const parent = wrap.parentElement?.getBoundingClientRect();
      const wraps = Boolean(
        show &&
          hide &&
          (show.offsetHeight > hide.offsetHeight + 1 || show.offsetTop !== hide.offsetTop || el.scrollWidth > el.clientWidth + 1 || (parent && el.getBoundingClientRect().right > parent.right + 1)),
      );
      wrap.dataset.short = String(wraps);
      setShort(wraps);
    };
    check();
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(check) : null;
    if (wrap.parentElement) ro?.observe(wrap.parentElement);
    return () => ro?.disconnect();
  }, []);
  return (
    <span class="show-hide" ref={host} data-short={String(short)}>
      <Segmented
        label={`${label}: show only or hide`}
        options={[
          [
            'show',
            <>
              Show<span class="show-only"> only</span>
            </>,
          ],
          ['hide', 'Hide'],
        ]}
        value={mode}
        onChange={onPick}
      />
    </span>
  );
}
